define('constants/routingRuleActionConstants',[], function() {
    return {
        created: "callflowCreated",
        unassigned: "callflowUnassigned",
        unchanged: "callflowUnchanged",
        updated: "callflowUpdated",
    };
});
